


const Header = ({ title, page }) => {


    const headerClassname = {
        'Home': 'header-home',
        'Eleanor': 'header-eleanor',
        'Mikey': 'header-mikey',
    }
    const textClassName = {
        'Home': '',
        'Eleanor': 'ella',
        'Mikey': 'mikey'
    }

    return (
        <div
        className={`edge-container header-container ${headerClassname[page]}`}
        >
            <div 
            
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                width: '100%',
            }}>

                <div
                className={`text header ${textClassName[page]}`}>
                    {title}
                </div>

            </div>
        </div>
    )


};

export default Header;